import * as React from "react"
import { client } from '@/api/client'

// Subscribes to realtime changes on an entity's rows for the current
// carrier and calls `onChange` (no payload -- callers just refetch their
// own query). Invalidate-and-refetch rather than patching individual rows
// into state: simplest, safest first version. No-ops until `carrierId`
// resolves -- see client.js's `subscribe()` implementation. Also a true
// no-op for any entity whose table hasn't been added to the
// `supabase_realtime` publication.
//
// `onChange` is stored in a ref rather than a useEffect dependency, so
// passing an inline/non-memoized function doesn't tear down and
// resubscribe the realtime channel on every render -- only a real
// `carrierId` change does that.
function useRealtimeEntity(entityName, carrierId, onChange) {
  const onChangeRef = React.useRef(onChange)
  onChangeRef.current = onChange

  React.useEffect(() => {
    if (!carrierId) return
    const unsubscribe = client.entities[entityName].subscribe(() => onChangeRef.current())
    return () => unsubscribe()
  }, [entityName, carrierId])
}

// e.g. LoadBoard's loadAll / ActiveLoad's loadData
export function useRealtimeLoads(carrierId, onChange) {
  useRealtimeEntity('Load', carrierId, onChange)
}

// e.g. LoadMapModal's live-position refetch while a load is In Transit
export function useRealtimeLoadPings(carrierId, onChange) {
  useRealtimeEntity('LoadLocationPing', carrierId, onChange)
}
